import { Provider } from '@angular/core';

import { AppInitializerService } from '@shared/services/app-initializer.service';
import { FileSaverService } from '@shared/services/file-saver.service';
import { ModuleClientService } from '@shared/services/module-client.service';
import { RouterService } from '@shared/services/router.service';
import { SeoService } from '@shared/services/seo.service';
import { SortingService } from '@shared/services/sorting.service';
import { ToastNotificationsService } from '@shared/services/toast-notifications.service';

export const APP_PROVIDERS: Provider[] = [
  AppInitializerService,
  FileSaverService,
  ModuleClientService,
  RouterService,
  SeoService,
  SortingService,
  ToastNotificationsService
];
